module.exports = __webpack_public_path__ + "static/media/wipers-on.c0f9502a.svg";